import FormInputStatus from "../../utils/enumerations/FormInputStatus";
import JsTypeInspector from "./JsTypeInspector";
import StringFormatter from "../../utils/formatters/StringFormatter";
import HtmlTagName from "../../utils/stringLiterals/HtmlTagName";
import PasswordConfig from "../../utils/configuration/PasswordConfig";



//TESTED
const inspectInputLength = function(inputName, inputStatus, inputValue){

    let inputLengthReport = {};
    const formInputStatusRequired = FormInputStatus[FormInputStatus.Required];
    const inputIsRequired = (inputStatus === formInputStatusRequired);
    const inputIsEmpty = JsTypeInspector.stringIsNullOrEmpty(inputValue);
    if( inputIsRequired && inputIsEmpty){
        const allCapitalLettersKey = StringFormatter.formatFirstLetterAsCapital(inputName);    
        inputLengthReport[`${inputName + formInputStatusRequired }`] = `${allCapitalLettersKey} is Required.`;
    }

    return inputLengthReport;
}

//TESTED
const inspectInputValue = function(inputName, inputValue){

    //console.log("inputName", inputName);
    let inputValueReport = {};
    const inputStatusInvalid = FormInputStatus[FormInputStatus.Invalid];
    switch(inputName){

        case HtmlTagName.EMAIL:
            const emailIsValidated = emailIsValid(inputValue);
            if(!emailIsValidated){
                const allCapitalLettersKey = StringFormatter.formatFirstLetterAsCapital(inputName);
                inputValueReport[`${inputName + inputStatusInvalid }`] = ` ${allCapitalLettersKey} is Invalid.`;
            }
            break;

        case HtmlTagName.PASSWORD:
        case HtmlTagName.CONFIRMPASSWORD:
            //console.log("inputName", inputName);
            //console.log("inputValue" , inputValue);
            const paswordIsValidated = passwordMinCharactersIsValid(inputValue, PasswordConfig.passwordMinCharacters);
            if(!paswordIsValidated){
                const allCapitalLettersKey = StringFormatter.formatFirstLetterAsCapital(inputName);
                inputValueReport[`${inputName + inputStatusInvalid }`] = ` ${allCapitalLettersKey} must be at least ${PasswordConfig.passwordMinCharacters} characters long.`;
            }
            
            break;

        case HtmlTagName.NAME:
        case HtmlTagName.FIRSTNAME:
        case HtmlTagName.LASTNAME:
        case HtmlTagName.MIDDLENAME:
            const nameIsValidated = nameIsValid(inputValue);
            if(!nameIsValidated){
                const allCapitalLettersKey = StringFormatter.formatFirstLetterAsCapital(inputName);
                inputValueReport[`${inputName + inputStatusInvalid }`] = ` ${allCapitalLettersKey} must contain only letters and spaces.`;
            }
            break;

        case HtmlTagName.DESCRIPTION:
        case HtmlTagName.USERNAME:
        case HtmlTagName.ROLE:
            const textIsValidated = textIsValid(inputValue);
            if(!textIsValidated){
                const allCapitalLettersKey = StringFormatter.formatFirstLetterAsCapital(inputName);
                inputValueReport[`${inputName + inputStatusInvalid }`] = ` ${allCapitalLettersKey} must contain only letters, numbers, dots and spaces.`;
            }
            break;

    }

    return inputValueReport;
}

const compareInputsAreEqual = function(inputObj){
    const inputsAreNotEqual = inputObj.input1Value !== inputObj.input2Value;
    const formInputStatusRequired = FormInputStatus[FormInputStatus.Required];
    let inputLengthReport = {};
    if( inputsAreNotEqual){
        const input1AllCapitalLettersKey = StringFormatter.formatFirstLetterAsCapital(inputObj.input1Name);
        const input2AllCapitalLettersKey = StringFormatter.formatFirstLetterAsCapital(inputObj.input2Name);

        inputLengthReport[`${inputObj.input2Name + formInputStatusRequired }`] = `${input2AllCapitalLettersKey} must be equal to ${input1AllCapitalLettersKey}.`;
    }

    return inputLengthReport;
}


const InputInspector = Object.freeze({
    inspectInputLength : inspectInputLength,
    inspectInputValue : inspectInputValue,
    compareInputsAreEqual : compareInputsAreEqual
});

export default InputInspector;

//#REGION Private Functions
function emailIsValid(input){
    const emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ ;
    const sqlSafePattern = /^[\w\s\.\,\-\/()&!?@:+=]*$/;
    const allEmailPatterns = [emailPattern, sqlSafePattern];

    const isValid = inputIsValid(allEmailPatterns, input);

    return isValid;
}

function passwordMinCharactersIsValid (input, minCharactersCount){
    const isValid = (input.length >= minCharactersCount);

    return isValid;
}

const nameIsValid = function(input){
    let namePattern = /^[\s]*[a-zA-Z\s ]*$/;
    let allNamePatterns = [namePattern];
    let isValid = inputIsValid(allNamePatterns, input);
    return isValid;
}

const textIsValid = function(input){
    let namePattern = /^[\s]*[a-zA-Z0-9\s .]*$/;
    let allNamePatterns = [namePattern];
    let isValid = inputIsValid(allNamePatterns, input);
    return isValid;
}


function inputIsValid(allInputPatterns, input){
    let allPatterns = [];
    for(let a = 0; a< allInputPatterns.length; a++)
    {
        const isInputValid = allInputPatterns[a].test(input);
        allPatterns.push(isInputValid);
    }
    const falseValue = allPatterns.find(input => input === false);
    var isValid = (falseValue === undefined);

    return isValid;
}
//#ENDREGION Private Functions